'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get4 = require('babel-runtime/helpers/get');

var _get5 = _interopRequireDefault(_get4);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _get6 = require('lodash/get');

var _get7 = _interopRequireDefault(_get6);

var _dec, _dec2, _dec3, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ClientSideComponent = require('core/ClientSideComponent');

var _ClientSideComponent2 = _interopRequireDefault(_ClientSideComponent);

var _reactI18next = require('react-i18next');

var _reactRedux = require('react-redux');

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _info = require('redux/modules/info');

var _auth = require('redux/modules/auth');

var authActions = _interopRequireWildcard(_auth);

var _common = require('redux/modules/common');

var commonActions = _interopRequireWildcard(_common);

var _components = require('components');

var _reactRouterRedux = require('react-router-redux');

var _config = require('config');

var _config2 = _interopRequireDefault(_config);

var _reduxConnect = require('redux-connect');

var _audioplayer = require('redux/modules/audioplayer');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _GA = require('components/GA');

var _GA2 = _interopRequireDefault(_GA);

var _toastr = require('helpers/toastr');

var _toastr2 = _interopRequireDefault(_toastr);

var _CookiePolicyBar = require('components/CookiePolicyBar/CookiePolicyBar');

var _CookiePolicyBar2 = _interopRequireDefault(_CookiePolicyBar);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = require('./App.scss');

var App = (_dec = (0, _reduxConnect.asyncConnect)([{
  promise: function promise(_ref) {
    var _ref$store = _ref.store,
        dispatch = _ref$store.dispatch,
        getState = _ref$store.getState;

    var promises = [];

    if (!(0, _info.isLoaded)(getState())) {
      //promises.push(dispatch(loadInfo()));
    }
    if (!authActions.isLoaded(getState())) {
      promises.push(dispatch(authActions.load()).promise);
    }

    return _promise2.default.all(promises);
  }
}]), _dec2 = (0, _reactRedux.connect)(function (state, ownProps) {
  return {
    action: ownProps.params.action,
    cookieBarHidden: state.adbar.cookieBarHidden,
    delayedToast: state.common.delayedToast,
    isMobile: state.common.isMobile,
    passwordCode: ownProps.location.query.code,
    passwordKey: ownProps.location.query.key,
    playlistKey: (0, _get7.default)(state, 'playlist.playlistActionData.key'),
    redirect: state.auth.redirect,
    user: state.auth.user
  };
}, (0, _extends3.default)({}, authActions, commonActions, { pushState: _reactRouterRedux.push, audioplayerStop: _audioplayer.stop })), _dec3 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = _dec3(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(App, _Component);

  function App() {
    (0, _classCallCheck3.default)(this, App);
    return (0, _possibleConstructorReturn3.default)(this, (App.__proto__ || (0, _getPrototypeOf2.default)(App)).apply(this, arguments));
  }

  (0, _createClass3.default)(App, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        getId: this.props.getId,
        isMobile: this.props.isMobile,
        logout: this.props.logout,
        push: this.props.pushState,
        t: this.props.t
      };
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      (0, _get5.default)(App.prototype.__proto__ || (0, _getPrototypeOf2.default)(App.prototype), 'componentDidMount', this).call(this, function () {
        require('smoothscroll-polyfill').polyfill();
        _this2.setViewport();
        _GA2.default.init(_config2.default.app.ga.devKey, { name: 'dev' });
        _GA2.default.pageview(_this2.props.location.pathname);
        _this2.showDelayedToast();
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (!this.props.user && nextProps.user) {
        this.onLogin(nextProps.user);
      } else if (this.props.user && !nextProps.user) {
        this.onLogout();
      }
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps) {
      if (nextProps.location.pathname !== this.props.location.pathname) {
        _GA2.default.pageview(nextProps.location.pathname);
      }
    }
  }, {
    key: 'onLogin',
    value: function onLogin() {
      var _props = this.props,
          redirect = _props.redirect,
          setRedirect = _props.setRedirect,
          removeLoginData = _props.removeLoginData;

      removeLoginData();
      if (redirect) {
        setRedirect('');
        this.props.pushState(redirect);
      } else {
        this.props.pushState(_config2.default.app.defaultUserRoute);
      }
    }
  }, {
    key: 'onLogout',
    value: function onLogout() {
      this.props.audioplayerStop();
      this.props.pushState('/');
      this.props.reset();
    }
  }, {
    key: 'setViewport',
    value: function setViewport() {
      // change viewports for macbooks
      var _screen = screen,
          width = _screen.width,
          height = _screen.height;

      var viewports = [{ devicePixelRatio: 2, width: 1280, height: 800, resize: 2 }, // MacBook Pro 13-inch Retina display
      { devicePixelRatio: 2, width: 1440, height: 900, resize: 2 }];

      viewports.map(function (params) {
        if (params.devicePixelRatio === window.devicePixelRatio && params.width === width && params.height === height) {
          var viewport = document.querySelector('#viewport');
          viewport.content = viewport.content.replace('width=device-width', 'width=' + Math.round(width * params.resize));
        }
      });
    }
  }, {
    key: 'showDelayedToast',
    value: function showDelayedToast() {
      var _props2 = this.props,
          _props2$delayedToast = _props2.delayedToast,
          type = _props2$delayedToast.type,
          message = _props2$delayedToast.message,
          clearDelayedToast = _props2.clearDelayedToast;

      if (__CLIENT__ && message) {
        _toastr2.default[type](message);
        clearDelayedToast();
      }
    }
  }, {
    key: 'renderHomePages',
    value: function renderHomePages(isLanding) {
      var _props3 = this.props,
          user = _props3.user,
          playlistKey = _props3.playlistKey,
          action = _props3.action,
          passwordCode = _props3.passwordCode,
          passwordKey = _props3.passwordKey;

      var isShowPlayer = user || playlistKey;

      return _react2.default.createElement(
        'div',
        { className: styles.homeRoot },
        _react2.default.createElement(_reactHelmet2.default, _config2.default.app.head),
        _react2.default.createElement(_components.AdBar, null),
        _react2.default.createElement(
          'div',
          { className: 'pos-rel' },
          _react2.default.createElement(_components.HomeHeader, { action: action, passwordCode: passwordCode, passwordKey: passwordKey, isLanding: isLanding })
        ),
        isShowPlayer && _react2.default.createElement(_components.AudioPlayer, null),
        _react2.default.createElement(
          'div',
          { className: styles.content },
          this.props.mainChild
        ),
        _react2.default.createElement(_components.Footer, null),
        _react2.default.createElement(_CookiePolicyBar2.default, null)
      );
    }
  }, {
    key: 'renderAppPages',
    value: function renderAppPages() {
      var _props4 = this.props,
          user = _props4.user,
          playlistKey = _props4.playlistKey;

      var isShowPlayer = user || playlistKey;

      return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)(styles.app, (0, _defineProperty3.default)({}, styles.withSideMenu, !!user)) },
        _react2.default.createElement(_reactHelmet2.default, _config2.default.app.head),
        _react2.default.createElement(
          'div',
          { className: styles.header },
          isShowPlayer && _react2.default.createElement(_components.AudioPlayer, null),
          user && _react2.default.createElement(_components.SideMenu, null),
          isShowPlayer ? _react2.default.createElement(_components.AppHeader, null) : _react2.default.createElement(_components.HomeHeader, { inApp: true })
        ),
        _react2.default.createElement(
          'div',
          null,
          this.props.mainChild
        ),
        _react2.default.createElement(_CookiePolicyBar2.default, null)
      );
    }
  }, {
    key: 'renderProcessingPages',
    value: function renderProcessingPages() {
      return _react2.default.createElement(
        'div',
        { className: styles.processingPage },
        this.props.mainChild,
        _react2.default.createElement(_CookiePolicyBar2.default, null)
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props5 = this.props,
          pathname = _props5.location.pathname,
          cookieBarHidden = _props5.cookieBarHidden;

      var isLanding = pathname === '/' || pathname.startsWith('/home') || pathname.startsWith('/password');
      var isHomePath = isLanding || pathname.startsWith('/service');
      var isProcessingPage = pathname.startsWith('/processing');

      return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)((0, _defineProperty3.default)({}, styles.cookieBarVisible, !cookieBarHidden)) },
        isHomePath ? this.renderHomePages(isLanding) : isProcessingPage ? this.renderProcessingPages() : this.renderAppPages()
      );
    }
  }]);
  return App;
}(_ClientSideComponent2.default), _class2.propTypes = {
  action: _propTypes2.default.string,
  audioplayerStop: _propTypes2.default.func,
  clearDelayedToast: _propTypes2.default.func,
  cookieBarHidden: _propTypes2.default.bool,
  delayedToast: _propTypes2.default.object,
  getId: _propTypes2.default.func,
  isMobile: _propTypes2.default.bool,
  location: _propTypes2.default.object,
  logout: _propTypes2.default.func,
  mainChild: _propTypes2.default.object.isRequired,
  passwordCode: _propTypes2.default.string,
  passwordKey: _propTypes2.default.string,
  playlistKey: _propTypes2.default.string,
  pushState: _propTypes2.default.func,
  redirect: _propTypes2.default.string,
  removeLoginData: _propTypes2.default.func,
  reset: _propTypes2.default.func,
  setRedirect: _propTypes2.default.func,
  t: _propTypes2.default.func,
  user: _propTypes2.default.object
}, _class2.defaultProps = {
  delayedToast: { type: 'info', message: null },
  user: null
}, _class2.contextTypes = {
  store: _propTypes2.default.object.isRequired,
  router: _propTypes2.default.object.isRequired
}, _class2.childContextTypes = {
  getId: _propTypes2.default.func,
  isMobile: _propTypes2.default.bool,
  logout: _propTypes2.default.func,
  push: _propTypes2.default.func,
  t: _propTypes2.default.func
}, _temp)) || _class) || _class) || _class);
exports.default = App;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/App/App.js
// module id = 2142
// module chunks = 1